export function formatTelemetryAttributes({ telemetryData, dimensionLookup = {}, excludeKeys = [], }) {
    return Object.keys(telemetryData)
        .filter((key) => {
        return !excludeKeys.includes(key);
    })
        .map((key) => {
        if (dimensionLookup[key]) {
            return {
                key: getCustomDimensionKey(dimensionLookup, key),
                value: telemetryData[key],
            };
        }
        return {
            key,
            value: getValue(telemetryData, key),
        };
    })
        .reduce((acc, { key, value }) => {
        acc[key] = value;
        return acc;
    }, {});
}
function getValue(data, key) {
    if (key === 'json') {
        return data[key] ? JSON.stringify(data[key]) : 'null';
    }
    return data[key] === undefined ? 'null' : data[key].toString();
}
function getCustomDimensionKey(lookup, key) {
    return `dimension${lookup[key]}`;
}
//# sourceMappingURL=format-telemetry-attributes.js.map